export default __webpack_public_path__ + "/dist/images/4215493.081c0b035bfc94423f30e7f084449040.png";